import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Patient } from "@/Common/Models/Patient/Patient";
import { PatientExternalIdentifier } from "@/Common/Models/Patient/PatientExternalIdentifier";
import * as LocalOperations from "@/Common/Operations/operations.local";

import "./PatientBannerExternalIdentifiers.css";

interface IPatientBannerProps {
    patient: Patient;
}

class PatientBannerExternalIdentifiers extends BaseReactComponent<IPatientBannerProps, any> {
    public render(): JSX.Element {
        const otherIds = this.props.patient.ExternalIdentifiers?.filter(p => p.IsVisible) ?? [];
        const externalSearchIdentifiersForActiveSite = this.props.patient.GetVisibleExternalIdentifersForActiveSite();
        // count other identifiers
        const currentIdentifersForActiveSite = externalSearchIdentifiersForActiveSite.map(actiVeSiteId => `${actiVeSiteId.SystemCode}_${actiVeSiteId.IndexCode}`);
        const otherIdsCountDisplay = otherIds
            .filter(p =>
                !currentIdentifersForActiveSite.contains(`${p.SystemCode}_${p.IndexCode}`)
            )
            .any() ? `+${otherIds.length}` : "";

        return (

            <div className="patient-banner-tooltip">
                {externalSearchIdentifiersForActiveSite.any() &&
                    (
                        <div
                            className="flex-container"
                            style={{ justifyContent: "flex-start" }}
                        >
                            <div>
                                <span className="glyphicon glyphicon-ok green-text" />
                            </div>
                            <div>
                                <a onClick={this.OpenExternalSearchPopup.bind(this)} style={{ whiteSpace: "nowrap", marginLeft: "3px" }}>
                                    {`${externalSearchIdentifiersForActiveSite[0].ShortName}${otherIdsCountDisplay}`}
                                </a>
                            </div>
                        </div>
                    )
                }
                {!externalSearchIdentifiersForActiveSite.any() &&
                cacheStore.GetPatientExternalSearchSystemCodesForActiveSite().map(systemCode => (
                    <div
                        key={`extIdent_${systemCode}`}
                        className="flex-container"
                        style={{ justifyContent: "flex-start" }}
                    >
                        <div><span className="glyphicon glyphicon-remove red-text" /></div>
                        <div>
                            <a onClick={this.OpenExternalSearchPopup.bind(this)} style={{ whiteSpace: "nowrap", marginLeft: "3px" }}>
                                {`${systemCode}${otherIdsCountDisplay}`}
                            </a>
                        </div>
                    </div>
                ))
                }

                {cacheStore.PatientExternalIdentifierIndexes?.length > 1 && (
                    <div className="tooltiptext">
                        {cacheStore.PatientExternalIdentifierIndexes
                            .filter(p => p.IsVisible)
                            .map(externalIndex => {
                                let matchingIndex = this.props.patient.ExternalIdentifiers
                                    ?.filter(p => p.SystemCode == externalIndex.SystemCode && p.IndexCode == externalIndex.IndexCode)
                                    .firstOrDefault();

                                return (
                                    <div key={`extIdent_tooltipItem_${externalIndex.SystemCode}_${externalIndex.IndexCode}`}>
                                        {matchingIndex != null && (
                                            <div className="flex-container flex-start">
                                                <div className="flex-container flex-start" style={{ width: "70px" }}>
                                                    <div>
                                                        <span className="glyphicon glyphicon-ok green-text" />
                                                    </div>
                                                    <div style={{ fontWeight: "bold", marginLeft: "5px" }}>
                                                        {externalIndex.Acronym ?? `${ externalIndex.SystemCode}-${externalIndex.IndexCode}`}
                                                    </div>
                                                </div>
                                                <div style={{ marginLeft: "5px" }}>
                                                    :
                                                </div>
                                                <div style={{ marginLeft: "5px" }}>
                                                    {`${matchingIndex.Number}`}
                                                </div>
                                            </div>
                                        )}
                                        {matchingIndex == null && (
                                            <div className="flex-container flex-start">
                                                <div className="flex-container flex-start" style={{ width: "70px" }}>
                                                    <div>
                                                        <span className="glyphicon glyphicon-remove red-text" />
                                                    </div>
                                                    <div style={{ fontWeight: "bold", marginLeft: "5px" }}>
                                                        {externalIndex.Acronym ?? `${ externalIndex.SystemCode}-${externalIndex.IndexCode}`}
                                                    </div>
                                                </div>
                                                <div style={{ marginLeft: "5px" }}>
                                                    :
                                                </div>
                                                <div style={{ marginLeft: "5px" }}>
                                                    {this.props.patient.PatientResponse.IsTest ? cacheStore.GetString("TestPatientPopupTitle") : cacheStore.GetString("NotSyncedOrDoesNotExist")}
                                                </div>

                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                    </div>
                )}
            </div>

        );
    }

    private async OpenExternalSearchPopup(): Promise<void> {
        if (!cacheStore.ClinicSettings.EnableExternalPatientSearch && cacheStore.GetPatientExternalSearchSystemCodesForActiveSite().any())
            return;

        sessionStore.dispatchMain(LocalOperations.MainComponentViewOperations.DisplayExternalSearch, {
            identifier: PatientExternalIdentifier.GetExternalSearchDefaultSearchForActiveSite(this.props.patient),
            patientContactId: this.props.patient.IndividualResponse.Contact_id,
            callback: () => patientStore.ActionsProfile.loadPatient(this.props.patient.IndividualResponse.Contact_id)
        });
    }
}

export { PatientBannerExternalIdentifiers };
